import React from "react";
import { string, bool, object, oneOf } from "prop-types";
import cx from "classnames";

import Icon from "../Icon/Icon.jsx";
import ArrowLink from "../ArrowLink/ArrowLink.jsx";

export const propTypes = {
  src: string.isRequired,
  loop: bool,
  title: string,
  autoplay: bool,
  hasAudio: oneOf(["True", "False", ""]), // Sitecore bool values
  poster: string,
  className: string,
  caption: string,
  credit: string,
  transcriptLink: object,
  darkButton: bool,
  smallButton: bool,
};

const BackgroundVideo = (props) => {
  const {
    src,
    loop,
    poster,
    className,
    title,
    autoplay,
    hasAudio = "False",
    transcriptLink,
    caption,
    credit,
    darkButton,
    smallButton,
  } = props;

  const reducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;

  const showCaption = title || caption || credit;
  const showDescription = transcriptLink || showCaption;

  const renderButton = () => (
    <button
      type="button"
      className={cx("background-video__button js-background-video-button", {
        "background-video__button--dark": darkButton,
        "background-video__button--small": smallButton,
        "background-video__button--audio": hasAudio === "True",
      })}
    >
      <span className="background-video__play-icon">
        Play or Pause the Video
        <Icon iconName="play-icon" />
      </span>
    </button>
  );

  const renderVideo = () => (
    // eslint-disable-next-line jsx-a11y/media-has-caption
    <video
      className="js-background-video-media background-video__media"
      src={src}
      muted={autoplay}
      loop={!autoplay && hasAudio ? false : loop}
      poster={poster}
      autoPlay={reducedMotion ? false : autoplay}
      playsInline={autoplay}
      data-has-audio={hasAudio}
      controlsList="nodownload"
    />
  );

  return (
    <section
      className={cx(
        `background-video component js-background-video ${className || ""}`,
        {
          "background-video--audio": hasAudio,
        },
      )}
    >
      {!showDescription && renderButton()}
      {!showDescription && renderVideo()}
      {showDescription && (
        <figure className="background-video__figure">
          <div className="background-video__media-wrapper">
            {renderButton()}
            {renderVideo()}
          </div>
          <div className="background-video__description">
            {showCaption && (
              <figcaption className="background-video__figure-caption">
                {title && (
                  <h2 className="background-video__title txt-heading-b">
                    {title}
                  </h2>
                )}
                {caption && (
                  <span className="background-video__caption">{caption}</span>
                )}
                {credit && (
                  <span className="background-video__credit">{credit}</span>
                )}
              </figcaption>
            )}
            {transcriptLink && (
              <div className="background-video__transcript">
                <ArrowLink {...transcriptLink} />
              </div>
            )}
          </div>
        </figure>
      )}
    </section>
  );
};
BackgroundVideo.propTypes = propTypes;
export default BackgroundVideo;
